/* eslint-disable linebreak-style */
/* eslint-disable comma-dangle */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

const AutoPlayVideo = ({ src, className }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
        }
      },
      { threshold: 0.3 }
    );

    if (video) observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return (
    <video
      ref={videoRef}
      src={src}
      loop
      muted
      playsInline
      preload="none"
      className={className}
    />
  );
};

AutoPlayVideo.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default AutoPlayVideo;
